import { computed, defineComponent, onMounted, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { BudgetTypeAction, BudgetTypeGetter } from '@/store/budgetType/budgetType.module';
import { BudgetType } from '@/store/budgetType/budgetType.model';
import { BudgetForm } from '@/store/project/project.model';

export default defineComponent({
  name: 'BudgetFormComponent',
  props: {
    budgets: {
      type: Object as PropType<BudgetForm[]>,
      required: true,
    }
  },
  emits: [
    'validated'
  ],
  setup: (props, context) => {
    const store = useStore();
    const toast = useToast();
    const budgetTypes = computed<BudgetType[]>(() => {
      const bTypes = store.getters[BudgetTypeGetter.ALL] as BudgetType[];
      return bTypes.filter(m => m.id !== 2 && budgetForm.value?.map(x => x.budgetTypeId).includes(m.id) === false);
    });
    const budgetForm = ref<BudgetForm[]>(props.budgets.map(m => {
      return {
        budgetTypeId: m.budgetTypeId,
        budgetTypeName: m.budgetTypeName,
        amount: m.amount
      };
    }));

    onMounted(() => {
      store.dispatch(BudgetTypeAction.FETCH);
    });

    watch(() => props.budgets, (budgets) => {
      budgetForm.value = budgets.map(m => {
        return {
          budgetTypeId: m.budgetTypeId,
          budgetTypeName: m.budgetTypeName,
          amount: m.amount
        };
      });
    });

    const addBudget = (budgetTypeId: number, shortName: string) => {
      budgetForm.value.push({
        budgetTypeId: budgetTypeId,
        budgetTypeName: shortName,
      });
    };

    const removeBudget = (budgetTypeId: number) => {
      const index = budgetForm.value.findIndex(m => m.budgetTypeId === budgetTypeId);
      budgetForm.value.splice(index, 1);
    };

    // submit form
    const submitForm = () => {
      if (budgetForm.value.length > 0 && budgetForm.value.every(m => m.amount && m.amount > 0)) {
        context.emit('validated', budgetForm.value);
      } else {
        toast.error(budgetForm.value.length > 0 ? 'ข้อมูลการจัดสรรงบประมาณไม่ถูกต้อง' : 'กรุณาป้อนข้อมูลการจัดสรรงบประมาณ');
      }
    };

    const clearForm = () => {
      budgetForm.value = props.budgets.map(m => {
        return {
          budgetTypeId: m.budgetTypeId,
          budgetTypeName: m.budgetTypeName,
          amount: m.amount };
      });
    };

    return {
      budgetForm,
      budgetTypes,
      addBudget,
      removeBudget,
      submitForm,
      clearForm,
    };
  },
});
